import { TextField as RffMuiTextField } from 'mui-rff';
import React from 'react';

import LabelField from '../LabelField';
import { useInputStyles } from './styles';

const TextField = ({
  label,
  name,
  type = 'text',
  size = 'small',
  variant = 'outlined',
  disableExternalLabel,
  InputProps,
  ...rest
}: any) => {
  const inputPropsClasses = useInputStyles();

  return (
    <>
      {!disableExternalLabel && <LabelField name={name}>{label}</LabelField>}
      <RffMuiTextField
        InputProps={
          InputProps && InputProps.classes
            ? {
                ...InputProps,
                classes: {
                  ...inputPropsClasses,
                  ...InputProps.classes,
                },
              }
            : InputProps
            ? {
                ...InputProps,
                classes: inputPropsClasses,
              }
            : { classes: inputPropsClasses }
        }
        {...rest}
        label={disableExternalLabel ? label : null}
        fullWidth
        type={type}
        size={size}
        variant={variant}
        name={name}
      />
    </>
  );
};

TextField.displayName = 'TextField';

export default TextField;
